<template>
  <div>
    <div class="main_box">
      <div>
        <!--操作栏-->
        <el-form @submit.native.prevent :inline="true">
          <el-form-item>
            <el-form-item label="角色名称" prop="date">
              <el-input v-model="searchForm.name" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-select
                v-model="searchForm.enableStatus"
                placeholder="请选择"
                filterable
                :clearable="true"
              >
                <el-option
                  v-for="(item,key) in statusList"
                  :key="key"
                  :label="item"
                  :value="key"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="创建时间" prop="createTime">
              <el-date-picker
                v-model="searchForm.createtime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="dateChange"
                :default-time="['00:00:00', '23:59:59']"
              >
              </el-date-picker>
            </el-form-item>
            <el-button type="primary" @click="loadData">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-button icon="el-icon-plus" @click="save()" type="primary">添加</el-button>
    </div>
    <div class="main_box_table">
      <el-table :data="roleList" border>
        <el-table-column prop="id" label="角色编号"></el-table-column>
        <el-table-column prop="name" label="角色名称"></el-table-column>
        <el-table-column prop="" label="启用状态">
          <template slot-scope="scope">
            <el-switch
              @change="changeStatus(scope.row)"
              active-value="1"
              inactive-value="0"
              v-model="scope.row.enableStatus">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间 "></el-table-column>
        <el-table-column fixed="right" width="160px" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="save(scope.row)" icon="el-icon-edit">修改</el-button>
            <el-button type="text" @click="deleteRole(scope.row)" icon="el-icon-delete">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex-r-e">
        <el-pagination
          v-show="total > 0"
          background=""
          layout="prev, pager, next, sizes, total, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 添加编辑弹窗 -->
    <el-dialog
      :title="dialogTitle == 0 ? '添加角色' : '编辑角色'"
      :visible.sync="roleDialogVisible"
      @close="dialogClose"
      append-to-body
    >
      <el-form
        :model="currentRole"
        ref="currentRole"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="角色名称：" prop="name">
              <el-input placeholder="请输入" v-model="currentRole.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="是否启用：" prop="description">
            <el-switch
              v-model="currentRole.enableStatus"
              active-value="1"
              inactive-value="0"
            >
            </el-switch>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="菜单权限：" prop="description">
              <el-tree
                :data="menuList"
                :default-checked-keys="defaultCheckedIds"
                show-checkbox
                default-expand-all
                node-key="id"
                ref="tree"
                highlight-current
                :props="defaultProps"
              >
              </el-tree>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose" class="cancel-btn"
          >取 消</el-button
        >
        <el-button type="primary" @click="submitRole('currentRole')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from "@/api";
var _self;
export default {
  data() {
    return {
      //分页
      pageNum: 1,
      pageSize: 10,
      total: 0,
      statusList: {
        0: "未启用",
        1: "启用"
      },
      searchForm: {
        name: "",
        enableStatus: "",
        createTime: ""
      },
      roleList: [],
      //弹窗
      roleDialogVisible: false,
      dialogTitle: 0, //新建为0，编辑为1
      currentRole: {
        name: '',
        enableStatus: '1',
        menuIds: ""
      },
      menuDialogVisible: false,
      //菜单管理
      menuList: [],
      defaultCheckedIds: [],
      defaultProps: {
        children: "children",
        label: "title"
      },
      rules: {
        name: [
          {
            required: true,
            message: "角色名称不能为空！",
            trigger: "blur"
          },
          {max: 20, message: '角色名称不能超过20位！', trigger: 'blur' }
        ]
      }
    };
  },

  created() {
    _self = this;
  },
  mounted() {
    _self.loadData();
    _self.getMenuList();
  },
  methods: {
    dialogClose() {
      _self.roleDialogVisible = false;
      if (_self.$refs.currentRole) {
        _self.$refs.currentRole.clearValidate();
        _self.$refs.currentRole.resetFields();
        _self.defaultCheckedIds=[]
        _self.$refs.tree.setCheckedKeys([]);
      }
    },
    dateChange() {
      if (_self.searchForm.createtime == null) _self.searchForm.createtime = [];
    },
    // 每页多少条
    handleSizeChange(val) {
      _self.pageSize = val;
      _self.loadData();
    },
    // 当前页
    handleCurrentChange(val) {
      _self.pageNum = val;
      _self.loadData();
    },
    loadData() {
      let param = {
        pageNum: _self.pageNum - 1,
        pageSize: _self.pageSize
      };
      api.roleAPI
        .getRoleList({ ...param, ..._self.searchForm })
        .then(res => {
          if (res.status == 200) {
            if (res.data.content.length == 0 && res.data.total != 0) {
              _self.pageNum -= 1;
              _self.loadData();
              return;
            }
            _self.roleList = res.data.content;
            _self.total = res.data.total;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    reset() {
      _self.searchForm = _self.$options.data().searchForm;
      _self.loadData();
    },
    changeStatus(row) {
      console.log(row);
      _self
        .$confirm("此操作将禁用/启用此项, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          api.roleAPI
            .updateRole(row)
            .then(res => {
              if (res.status == 200) {
                this.$message.success("操作成功");
                _self.loadData();
                _self.roleDialogVisible = false;
              } else {
                this.$message.error(res.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
    },
    //添加
    save(row) {
      if (row) {
        //编辑
        _self.dialogTitle = 1;
        _self.currentRole = JSON.parse(JSON.stringify(row));
        api.roleAPI
          .getMenuListByRoleId(row)
          .then(resp => {
            console.log("getMenuListByRoleId", resp);
            if (resp.status == 200) {
              for (let index in resp.data.menuVos) {
                if (
                  resp.data.menuVos[index].level == 2 ||
                  (resp.data.menuVos[index].level == 1 &&
                    resp.data.menuVos[index].component != null)
                ) {
                  _self.defaultCheckedIds.push(resp.data.menuVos[index].id);
                }
              }
              _self.roleDialogVisible = true;
            }
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        //添加
        _self.dialogTitle = 0;
        _self.currentRole = this.$options.data().currentRole;
        _self.roleDialogVisible = true;
      }
    },
    submitRole() {
      this.$refs["currentRole"].validate(valid => {
        if (valid) {
          let allMenuId = [].concat(
            this.$refs.tree.getCheckedKeys(),
            this.$refs.tree.getHalfCheckedKeys()
          );
          _self.currentRole.menuIds = allMenuId.toString();
          if(_self.dialogTitle == 0){
            api.roleAPI
              .saveRole(_self.currentRole)
              .then(res => {
                if (res.status == 200) {
                  this.$message.success("操作成功");
                  _self.loadData();
                  _self.roleDialogVisible = false;
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          }else {
            api.roleAPI
              .updateRole(_self.currentRole)
              .then(res => {
                if (res.status == 200) {
                  this.$message.success("操作成功");
                  _self.loadData();
                  _self.roleDialogVisible = false;
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          }

        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    deleteRole(row) {
      _self
        .$confirm("此操作将永久删除此项, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          row.deleteFlg = "1";
          api.roleAPI
            .deleteRole(row)
            .then(res => {
              if (res.status == 200) {
                this.$message.success("操作成功");
                _self.loadData();
              } else {
                this.$message.error(res.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    //获取菜单tree
    async getMenuList() {
      let res = await api.menuAPI.getAllMenu();
      _self.menuList = res.data;
      console.log(_self.menuList,'menuList');
    }
  }
};
</script>
<style lang="scss" scoped>
.el-tree {
  border: 1px solid #D9D9D9 !important;
}
</style>
